var _defs, _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageErrorIcon = function SvgPageErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "page-error-icon_svg__Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 126.8 140.81",
    className: "svgr-icon"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".page-error-icon_svg__cls-1{fill:#fee1bf}.page-error-icon_svg__cls-2{fill:#ef7c7e}.page-error-icon_svg__cls-3{fill:#9ed7ee}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.63,
    cy: 119.11,
    r: 13.99,
    className: "page-error-icon_svg__cls-1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.68,
    cy: 136.68,
    r: 4.13,
    className: "page-error-icon_svg__cls-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 107.23a3 3 0 0 1-2.6-4.51l47.66-82.55a3 3 0 0 1 5.2 0l47.66 82.55a3 3 0 0 1-2.6 4.51Z",
    className: "page-error-icon_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.67 19.67a2 2 0 0 1 1.74 1l23.83 41.28 23.83 41.27a2 2 0 0 1-1.74 3H17.01a2 2 0 0 1-1.73-3l23.83-41.27 23.82-41.28a2 2 0 0 1 1.73-1m0-2a4 4 0 0 0-3.46 2L37.38 60.95l-23.83 41.27a4 4 0 0 0 3.46 6h95.32a4 4 0 0 0 3.47-6L91.93 60.95 68.14 19.67a4 4 0 0 0-3.47-2Z",
    className: "page-error-icon_svg__cls-2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.15,
    cy: 21.7,
    r: 13.99,
    className: "page-error-icon_svg__cls-3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1,
    cy: 4.13,
    r: 4.13,
    className: "page-error-icon_svg__cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.07 26.08a2 2 0 0 1 1.75 1l24 41.59 24 41.58a2 2 0 0 1-1.75 3h-96a2 2 0 0 1-1.75-3l24-41.58 24-41.59a2 2 0 0 1 1.75-1m0-2a4 4 0 0 0-3.48 2l-24 41.59-24 41.58a4 4 0 0 0 3.48 6h96a4 4 0 0 0 3.48-6l-24-41.58-24-41.59a4 4 0 0 0-3.48-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.61 98.52a3.46 3.46 0 1 1 3.52 3.46 3.46 3.46 0 0 1-3.52-3.46m1.32-11.87V53.06a.93.93 0 0 1 .84-1h3a.93.93 0 0 1 .85 1v33.59a.93.93 0 0 1-.85 1h-3a.93.93 0 0 1-.84-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.07 27.42a3.32 3.32 0 0 1 2.91 1.68l22.85 39.58 22.85 39.57a3.36 3.36 0 0 1-2.92 5H7.38a3.36 3.36 0 0 1-2.91-5l22.84-39.57L50.16 29.1a3.33 3.33 0 0 1 2.91-1.68m0-4a7.32 7.32 0 0 0-6.38 3.68L23.85 66.68 1 106.25a7.36 7.36 0 0 0 6.38 11h91.38a7.36 7.36 0 0 0 6.38-11L82.29 66.68 59.45 27.1a7.3 7.3 0 0 0-6.38-3.68"
  })));
};
export default SvgPageErrorIcon;